import EventManager from './EventManager'
import Message from "./BaseMessage"
import IframeMessage from './IframeMessage'
import WebviewMessage from './WebviewMessage'
import config from "./config";


class MessageProxy extends Message {
    constructor(...args) {
        super(...args)
        this.msgFromBroadcast = new EventManager()
        this.msgFromAnyView = new EventManager()
        this.msgFromSuperView = new EventManager()
        this.msgFromSubView = new EventManager()

        this.iframeMsg = new IframeMessage()
        this.webviewMsg = new WebviewMessage()

        this.webviewMsg.onBroadcastAll(event=>{
            this._onWebviewBroadcast(event)
        })
        this.iframeMsg.onBroadcastAll(event=>{
            console.log("子iframe 获取到 message...",event, location.href)
            this._onIframeBroadcast(event)
        })
    }


    broadcast(eventName, data) {
        super.broadcast(eventName, data)
        //this.iframeMsg.broadcast(eventName, data)
        //this.webviewMsg.broadcast(eventName, data)
    }

    _fireAllIframeViews(data){
        const ifrs = document.querySelectorAll('iframe.container-iframe')
        console.log("子iframe 获取到 go message.forrrrr",data, ifrs, location.href)
        ifrs.forEach(ifr => {
            ifr.contentWindow.postMessage(data, '*')
        })
    }

    _onIframeBroadcast(event){
        const outerBody = event
        const innerBody = event.data
        const { eventName, data } = innerBody || {}
        console.log("子iframe 获取到 go message.DDDD22222",event, config, location.href)
        if(outerBody.eventName === Message.MSG_TO_SPECIFIED_VIEW){
            console.log("子iframe 获取到 message...111",event, location.href)
            this.msgFromSuperView.fire(eventName, data)
            this.msgFromAnyView.fire(eventName, data)
        }else if(outerBody.eventName === Message.MSG_TO_SUPER_VIEW){
            console.log("子iframe 获取到 go message...222",outerBody, innerBody, location.href,window.__vcm,config)
            if(config.viewMap[innerBody.id] && innerBody.id!==config.iframeViewId&& innerBody.id!==config.webviewId){
                this.msgFromSubView.fire(eventName, data)
                this.msgFromAnyView.fire(eventName, data)
            }else{
                // 消息转发给子视图
                this._fireAllIframeViews(outerBody)
            }

        }else {
            console.log("子iframe 获取到 go message...333",event, location.href)
            this.msgFromBroadcast.fire(outerBody.eventName, outerBody.data)
            this.msgFromAnyView.fire(outerBody.eventName, outerBody.data)
            // 消息转发给子视图
            this._fireAllIframeViews(outerBody)
        }
    }

    _onWebviewBroadcast(event){

        const outerBody = event
        const innerBody = event.data
        const { data } = event
        console.log("子iframe 获取到 go Webview.DDDD333",event, config, location.href)

        //if(eventName===data.eventName){
        if(outerBody.eventName === Message.MSG_TO_SPECIFIED_VIEW){
            console.log("子iframe 获取到 go Webview...2222",event, location.href)
            if(innerBody.id === config.webviewId){
                this.msgFromSuperView.fire(innerBody.eventName, innerBody.data)
                this.msgFromAnyView.fire(innerBody.eventName, innerBody.data)
            }else{
                // 消息转发给子视图
                // this._fireAllIframeViews(outerBody)
            }
        }else if(outerBody.eventName === Message.MSG_TO_SUPER_VIEW){
            console.log("子iframe 获取到 go Webview...1111",event, location.href)
            if(config.viewMap[innerBody.id] && innerBody.id!==config.webviewId){
                this.msgFromSubView.fire(innerBody.eventName, innerBody.data)
                this.msgFromAnyView.fire(innerBody.eventName, innerBody.data)
            }else{
                // 消息转发给子视图
                this._fireAllIframeViews(outerBody)
            }
        }else {
            console.log("子iframe 获取到 go Webview...3333",event, location.href)
            this.msgFromBroadcast.fire(outerBody.eventName, outerBody.data)
            this.msgFromAnyView.fire(outerBody.eventName, innerBody)
            // 消息转发给子视图
            this._fireAllIframeViews(outerBody)
        }
    }

    /*_onWebviewBroadcast(event){
        const { data } = event
        console.log("子iframe 获取到 add message.DDDD333",event, config, location.href)

        //if(eventName===data.eventName){
        if(event.eventName === Message.MSG_TO_SUPER_VIEW){
            if(config.viewMap[data.id] && data.id!==config.viewId){
                this.msgFromSuperView.fire(data.eventName, data.data)
                this.msgFromAnyView.fire(data.eventName, data.data)
            }else{
                // 消息转发给子视图
                this._fireAllIframeViews(data)
            }
        }else if(event.eventName === Message.MSG_TO_SPECIFIED_VIEW){
            if(data.id === config.viewId){
                this.msgFromSubView.fire(data.eventName, data.data)
                this.msgFromAnyView.fire(data.eventName, data.data)
            }else{
                // 消息转发给子视图
                this._fireAllIframeViews(data)
            }
        }else {
            this.msgFromAnyView.fire(event.eventName, event.data)
            // 消息转发给子视图
            this._fireAllIframeViews(event)
        }
    }*/

    onBroadcast(eventName, cb) {
        this.msgFromBroadcast.addEventListener(eventName, cb)
    }
    onMessage(eventName, cb) {
        this.msgFromAnyView.addEventListener(eventName, cb)
    }

    //向特定视图发送消息 （使用onSuperViewEmitMessage方法接收消息）
    emitMessageToView(view, eventName, data = {}) {
        const el = view.element
        // console.log("子iframe 获取到发送msg", (el && el instanceof HTMLDocument),el, el instanceof HTMLDocument, this.iframeMsg,view, eventName, data,location.href)
        //如果视图是 iframe 视图
        if (el/* && el instanceof HTMLDocument*/) {
            this.iframeMsg.emitMessageToView(view, eventName, data)
        } else {
            this.webviewMsg.emitMessageToView(view, eventName, data)
        }
    }

    //向父视图发送消息  emitMessageToSuperView
    //如果当前为非顶层window视图（iframe），emitMessageToSuperView操作发送给父window视图
    //如果当前是顶层window视图，则emitMessageToSuperView操作发送给父webview视图
    emitMessageToSuperView(eventName, data = {}) {
        if (window.parent !== window) {
            console.log('iframeMsg 向父视图发送消息->', window.location.href)
            this.iframeMsg.emitMessageToSuperView(eventName, data)
        } else {
            console.log('webviewMsg 向父视图发送消息->', window.location.href)
            this.webviewMsg.emitMessageToSuperView(eventName, data)
        }
    }

    //考虑删除
    onSubViewEmitMessage(eventName, cb) {
        this.msgFromSubView.addEventListener(eventName, cb)
    }
    //考虑删除
    onSuperViewEmitMessage(eventName, cb) {
        this.msgFromSuperView.addEventListener(eventName, cb)
    }
}


export default MessageProxy